module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/vpay-0c0648edf19d91945017440fc782ad3f.svg";